// extracted by mini-css-extract-plugin
export default {"container":"SendMail_container__N4rah","send-container":"SendMail_send-container__CsTgY","input":"SendMail_input__HnvY7","button":"SendMail_button__zv77z"};